
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import ListProducts from './ListProducts';


function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);

    const [showCategories, setshowCategories] = useState(false);
     const [showListProduct, setShowListProduct2] = useState(false);
    

    const [menusData, setMenusData] = useState([]);
     const [menus, setMenus] = useState(menusCurrent);
     const [dishs2, setdishs] = useState(false);
    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);

    const [Beverages, setBeverages] = useState(false);
  

     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);


      useEffect(() => {
        menusData.map((item) => {
            
            if (item.id === 866) {
                setBeverages(item);
            }
        });
      }, [menusData]);
    
    
    const GoBeverages = () => {
         setShowListProduct2(true)
                setdishs(Beverages)
       
    }


    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
                GoBeverages()
            }}  showLamp={ false} showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials}>
                
              
                <div >
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                        
                    
                        <div style={{ width: '30%', height: '100%', paddingInline: 10}}>
                            <img src={require('./assets/bannerlist.png')}
                                style={{ width: '100%', height: 710, objectFit: 'cover', marginTop: 10, borderRadius: 20 }} />
                    </div>
                        <div style={{
                        
                       
                            display: 'flex',
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            gap: '2%',
                            padding: '0px 0px 100px 0px',
                          
                        overflow: 'scroll',
                      
                        
                        position: 'relative',
                        zIndex: 100,
                        width: '70%',
                       
                            
                            
                        }}>

                            <img src={require('./assets/banderas.png')} style={{ width: '100%', height: 100, objectFit: 'contain', borderRadius: 20, marginBottom: 20 }} />
                            <img src={require('./assets/CUADROLISTA.png')} style={{ width: '100%', height: 600, objectFit: 'contain', borderRadius: 20 }} />
                           
                        


              
                        </div>   
                        </div>
                    
      
                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
               
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                
 {showListProduct && <ListProducts
                dishs={dishs2}
                setShowListProduct={setShowListProduct}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;